import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ChipsModule } from 'primeng/chips';
import { CollectionRoutingModule } from './collection-routing.module';
import { EmailModelComponent } from './components/vendor-registration/email-model/email-model.component';
@NgModule({
    declarations: [EmailModelComponent],
    imports: [
        CollectionRoutingModule,
        MaterialModule,
        LayoutModule,
        SharedModule,
        MatDatepickerModule,
        ChipsModule,
        AngularEditorModule
    ],
    providers: [
        DatePipe
    ],
    entryComponents:[EmailModelComponent]
})
export class CollectionModule { }
